import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { computed, onMounted, ref, shallowRef } from 'vue';
import Dialog from 'primevue/dialog';

import { AddAdmin, AddOrganization, AddTenant, Steps } from './steps';
import { useOrganizationStore, usePeopleStore, usePeopleTypesStore, useTenantStore } from '@/store';
import { EMIT } from '@/enum';
import { useToast } from 'primevue/usetoast';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddTenantWizard',
  emits: [EMIT.CANCEL, EMIT.SAVE],
  setup(__props, { emit: __emit }) {

const tenantStore = useTenantStore();
const peopleStore = usePeopleStore();
const organizationStore = useOrganizationStore();
const peopleTypeStore = usePeopleTypesStore();

const emit = __emit;
const modalVisible = ref(true);
const toast = useToast();
const PEOPLE_TYPES = peopleTypeStore.PEOPLE_TYPES;

const items = [
  {
    id: 0,
    allowNavigate: true,
    component: AddTenant,
    complete: false,
  },
  {
    id: 1,
    allowNavigate: false,
    component: AddOrganization,
    complete: false,
  },
  {
    id: 2,
    allowNavigate: false,
    component: AddAdmin,
    complete: false,
  },
];

const step = shallowRef(items[0]);

onMounted(() => {
  init();
});

/**
 * get the people types so we can attach the admin type ID to the admin People object
 */
const init = () => {
  if (!peopleTypeStore.types.length) peopleTypeStore.getPeopleTypes();
};

const loading = computed(() => tenantStore.loading || organizationStore.loading || peopleStore.loading);
/**
 * on Next button press either go to the next for or submit the whole shebang
 */
const handleFormNext = () => {
  if (step.value.id < 2) {
    step.value.allowNavigate = true;
    step.value.complete = true;
    step.value = items[step.value.id + 1];
  }
};

/**
 * save the tenant, admin and org through their respective stores
 */
const handleFormSave = async () => {
  try {
    setPayload();
    await tenantStore.saveTenant();
    doToast(false, 'Tenant Saved');
    modalVisible.value = false;
    emit(EMIT.SAVE);
  } catch (e) {
    doToast(true, 'something went wrong. please try again ');
  }
};

/**
 * set the payload data for the Tenant, Org, and Admin
 */
const setPayload = () => {
  setAdminPersonType();
  tenantStore.newTenant.timezone_id = tenantStore.newAdmin.timezone_id;
  tenantStore.newTenant.email = tenantStore.newAdmin.email;
};

/**
 * set the proper person type based on PeopleTypes from the storeApi for the admin we are creating
 */
const setAdminPersonType = () => {
  const personType = peopleTypeStore.types.find((type) => type.acronym === PEOPLE_TYPES.SCHOOL_ADMIN);
  if (personType) tenantStore.newAdmin.person_type_id = personType.id;
};

/**
 * Display the toast message.
 */
const doToast = (error: boolean, msg?: string) => {
  toast.add({
    severity: error ? 'error' : 'success',
    summary: error ? 'Error' : 'Saved',
    detail: msg,
    life: 3000,
  });
};

/**
 * on Back make sure the next form has allowed Navigation and then go there
 */
const handleFormBack = () => {
  const newStep = items[step.value.id - 1];
  if (newStep.allowNavigate && step.value.id > 0) step.value = newStep;
};

/**
 * Handle the cancellation of the user create modal.
 */
const onCancel = () => {
  modalVisible.value = false;
  emit(EMIT.CANCEL);
};

return (_ctx: any,_cache: any) => {
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: modalVisible.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((modalVisible).value = $event)),
    modal: true,
    header: "Create New Tenant",
    draggable: false,
    breakpoints: { '960px': '75vw', '640px': '100vw' },
    style: { minWidth: '600px' },
    class: "wizard_dialog__container",
    onHide: onCancel
  }, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            relative: true,
            class: "flex justify-content-center align-items-center h-full loader"
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(Steps), {
        id: step.value.id
      }, null, 8, ["id"]),
      (step.value.id === 0)
        ? (_openBlock(), _createBlock(_unref(AddTenant), {
            key: 1,
            onNext: handleFormNext
          }))
        : _createCommentVNode("", true),
      (step.value.id === 1)
        ? (_openBlock(), _createBlock(_unref(AddOrganization), {
            key: 2,
            onNext: handleFormNext,
            onBack: handleFormBack
          }))
        : _createCommentVNode("", true),
      (step.value.id === 2)
        ? (_openBlock(), _createBlock(_unref(AddAdmin), {
            key: 3,
            onSave: handleFormSave,
            onBack: handleFormBack
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})